export const siteName = '私拍吃瓜';

export const updateTicker = [
  '第 07 期封面已更，放大入口先开后细节',
  '同款区新挂 3 组对照，来源与时间都标好了',
  '反光频道补了两处窗面反射，逐帧可查',
  '背景区新增一段街景，比对基准已对齐',
  '细节档案本周更新 12 条，按截图时间排序',
];

export const entryTabs = [
  {
    key: 'zoom',
    label: '放大',
    icon: 'ri-zoom-in-line',
    title: '私拍吃瓜放大：先看清，再判断',
    desc: '把整帧推到最大，看纹理、看边缘、看像素落差。放大不是为了刺激，而是为了把每一处争议点摊在明面上，让细节自己说话。',
    image:
      'https://readdy.ai/api/search-image?query=Extreme%20macro%20shot%20of%20a%20magnifying%20glass%20resting%20over%20a%20printed%20photograph%20on%20warm%20cream%20paper%2C%20amber%20editorial%20lighting%2C%20fine%20paper%20texture%20visible%2C%20artistic%20still%20life%2C%20high%20detail&width=900&height=700&seq=spcg-zoom-01&orientation=landscape&nocache=true',
    stats: [
      { label: '本期放大条目', value: '48' },
      { label: '平均倍率', value: '6.2x' },
    ],
  },
  {
    key: 'detail',
    label: '细节',
    icon: 'ri-focus-3-line',
    title: '私拍吃瓜细节：逐帧确认的小证据',
    desc: '配饰、表盘、衣料走线，凡是能在连续帧里被反复确认的元素，我们都会留档。细节区更像一本可翻阅的档案，而不是一次性的热闹。',
    image:
      'https://readdy.ai/api/search-image?query=Sharp%20macro%20detail%20of%20a%20vintage%20watch%20and%20brass%20ring%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20directional%20light%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tone%2C%20high%20detail&width=900&height=700&seq=spcg-detail-01&orientation=landscape&nocache=true',
    stats: [
      { label: '细节档案', value: '312' },
      { label: '本周新增', value: '12' },
    ],
  },
  {
    key: 'match',
    label: '同款',
    icon: 'ri-shirt-line',
    title: '私拍吃瓜同款：把相似的摆在一起',
    desc: '同款不靠一句“看着像”。我们把候选物件并排放，标出工艺、批次和可核对的差异点，让你自己决定像不像。',
    image:
      'https://readdy.ai/api/search-image?query=Two%20similar%20minimal%20garments%20arranged%20side%20by%20side%20on%20a%20cream%20studio%20backdrop%2C%20warm%20soft%20lighting%2C%20editorial%20fashion%20flatlay%2C%20muted%20earth%20tones%2C%20clean%20composition&width=900&height=700&seq=spcg-match-01&orientation=landscape&nocache=true',
    stats: [
      { label: '同款对照组', value: '126' },
      { label: '本期新挂', value: '3' },
    ],
  },
  {
    key: 'bg',
    label: '背景',
    icon: 'ri-landscape-line',
    title: '私拍吃瓜背景：线索往往在边角',
    desc: '招牌、路牌、窗框、季节光线，背景里能读出的信息比想象中多。我们把背景单独裁出来看，再放回整帧核对。',
    image:
      'https://readdy.ai/api/search-image?query=Blurred%20warm%20city%20street%20background%20with%20amber%20evening%20light%2C%20soft%20bokeh%20shop%20signs%2C%20editorial%20travel%20photography%2C%20muted%20earth%20tones%2C%20cinematic%20atmosphere&width=900&height=700&seq=spcg-bg-01&orientation=landscape&nocache=true',
    stats: [
      { label: '背景图档', value: '89' },
      { label: '可定位', value: '41' },
    ],
  },
  {
    key: 'reflection',
    label: '反光',
    icon: 'ri-sun-line',
    title: '私拍吃瓜反光：玻璃与镜面会说真话',
    desc: '窗面、镜面、车漆上的倒影，常是被忽略的第三方视角。反光区专门收这些角落，逐帧放大再比轮廓。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20amber%20light%20reflecting%20on%20a%20window%20glass%20surface%20with%20soft%20bokeh%20highlights%2C%20abstract%20editorial%20photography%2C%20golden%20tone%2C%20minimal%20and%20artistic&width=900&height=700&seq=spcg-reflect-01&orientation=landscape&nocache=true',
    stats: [
      { label: '反光点位', value: '57' },
      { label: '待核对', value: '9' },
    ],
  },
];

export const gridEntries = [
  {
    id: 'g1',
    size: 'large',
    tag: '封面',
    title: '被放大的那三秒：纹理、边缘与光斑的完整读法',
    excerpt:
      '同一段画面里，衣料纹理和背景光斑的时间差只有两帧。我们把这段单独裁出来，配合截图逐帧标注，方便你对照反光和同款两条线。',
    image:
      'https://readdy.ai/api/search-image?query=Large%20warm%20editorial%20still%20life%20of%20scattered%20instant%20film%20photos%20and%20a%20magnifier%20on%20cream%20paper%2C%20amber%20lighting%2C%20artistic%20magazine%20cover%20composition%2C%20high%20detail&width=1200&height=800&seq=spcg-grid-lead&orientation=landscape&nocache=true',
    time: '09月10日 · 21:40',
    reads: '1.8万',
    span: '明暗反差',
  },
  {
    id: 'g2',
    size: 'small',
    tag: '反光',
    title: '窗面倒影里的第二个轮廓',
    excerpt: '左侧玻璃映出的位置和主体错开约半步，这个差值值得单独记一笔。',
    image:
      'https://readdy.ai/api/search-image?query=Soft%20amber%20light%20reflection%20on%20glass%20window%20with%20warm%20bokeh%2C%20minimal%20editorial%20detail%20shot%2C%20golden%20neutral%20tone&width=700&height=560&seq=spcg-grid-r1&orientation=landscape&nocache=true',
    time: '09月10日 · 19:12',
    reads: '6,420',
    span: '镜面',
  },
  {
    id: 'g3',
    size: 'small',
    tag: '同款',
    title: '领口走线对上了哪一批',
    excerpt: '针脚密度和包边方式落到两个批次之间，剩下的靠你自己看。',
    image:
      'https://readdy.ai/api/search-image?query=Close%20macro%20of%20garment%20collar%20stitching%20on%20warm%20beige%20fabric%2C%20soft%20directional%20light%2C%20editorial%20textile%20detail%2C%20muted%20earth%20tone&width=700&height=560&seq=spcg-grid-m1&orientation=landscape&nocache=true',
    time: '09月10日 · 16:05',
    reads: '5,180',
    span: '工艺',
  },
  {
    id: 'g4',
    size: 'small',
    tag: '背景',
    title: '街角招牌的季节线索',
    excerpt: '招牌灯箱只亮了一半，结合光线角度能大致圈出月份范围。',
    image:
      'https://readdy.ai/api/search-image?query=Blurred%20amber%20shop%20sign%20with%20warm%20evening%20glow%20on%20a%20city%20street%2C%20soft%20bokeh%20background%2C%20editorial%20urban%20detail%20photography%2C%20muted%20tone&width=700&height=560&seq=spcg-grid-b1&orientation=landscape&nocache=true',
    time: '09月09日 · 22:30',
    reads: '4,760',
    span: '街景',
  },
  {
    id: 'g5',
    size: 'small',
    tag: '细节',
    title: '指节上的那点高光',
    excerpt: '高光位置和上一帧有位移，说明光源在动，不是后期加的。',
    image:
      'https://readdy.ai/api/search-image?query=Macro%20detail%20of%20a%20hand%20with%20brass%20ring%20under%20warm%20soft%20light%2C%20subtle%20highlight%2C%20editorial%20minimal%20photography%2C%20cream%20neutral%20background&width=700&height=560&seq=spcg-grid-d1&orientation=landscape&nocache=true',
    time: '09月09日 · 20:14',
    reads: '3,980',
    span: '光源',
  },
  {
    id: 'g6',
    size: 'small',
    tag: '放大',
    title: '把噪点也列进证据清单',
    excerpt: '放大后噪点分布是连续的，这一点能帮我们区分压缩和翻拍。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20grain%20texture%20macro%20of%20film%20noise%20on%20cream%20paper%2C%20amber%20tint%2C%20editorial%20minimal%20detail%2C%20artistic%20texture%20study&width=700&height=560&seq=spcg-grid-z1&orientation=landscape&nocache=true',
    time: '09月09日 · 15:47',
    reads: '3,210',
    span: '纹理',
  },
];

export const methodSteps = [
  {
    no: '01',
    title: '先整帧，再局部',
    desc: '不急着放大。先把整帧看一遍，记下时间、光线和构图，再决定从哪儿切进去。',
  },
  {
    no: '02',
    title: '标出可核对的点',
    desc: '只记录能在两帧以上重复出现的元素：走线、倒影、招牌缺口，其余先放一边。',
  },
  {
    no: '03',
    title: '把截图和片段并排放',
    desc: '截图看静态，片段看变化，两条线放在一起，矛盾的地方自然会浮出来。',
  },
  {
    no: '04',
    title: '留下不确定',
    desc: '说不准的就写说不准，档案里保留待核对状态，比硬下结论更有用。',
  },
];

export const matchPairs = [
  {
    id: 'p1',
    label: '衣料 · 包边',
    note: '左侧为截图裁切，右侧为同款候选。差异点落在包边宽度，约差 1.5 毫米。',
    shot:
      'https://readdy.ai/api/search-image?query=Macro%20crop%20of%20garment%20edge%20binding%20stitching%20on%20warm%20beige%20fabric%2C%20soft%20light%2C%20editorial%20textile%20detail%2C%20neutral%20tone&width=800&height=800&seq=spcg-pair-a1&orientation=squarish&nocache=true',
    cand:
      'https://readdy.ai/api/search-image?query=Macro%20crop%20of%20a%20similar%20garment%20edge%20seam%20with%20slightly%20wider%20binding%20on%20cream%20fabric%2C%20soft%20light%2C%20editorial%20textile%20detail&width=800&height=800&seq=spcg-pair-a2&orientation=squarish&nocache=true',
  },
  {
    id: 'p2',
    label: '五金 · 表扣',
    note: '右侧表扣的拉丝方向相反，其余尺寸、孔位基本一致，列为高度相似候选。',
    shot:
      'https://readdy.ai/api/search-image?query=Macro%20of%20a%20brushed%20metal%20watch%20clasp%20on%20a%20warm%20neutral%20surface%2C%20soft%20directional%20light%2C%20editorial%20product%20detail&width=800&height=800&seq=spcg-pair-b1&orientation=squarish&nocache=true',
    cand:
      'https://readdy.ai/api/search-image?query=Macro%20of%20a%20similar%20brushed%20metal%20clasp%20with%20opposite%20brush%20direction%20on%20a%20cream%20surface%2C%20soft%20light%2C%20editorial%20product%20detail&width=800&height=800&seq=spcg-pair-b2&orientation=squarish&nocache=true',
  },
];

export const reflectionSpots = [
  {
    id: 'r1',
    tag: '窗面',
    title: '左二窗格的半身轮廓',
    desc: '倒影中肩线比主体高一格，说明拍摄点在移动，而不是被摄者转身。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20reflection%20of%20a%20silhouette%20in%20a%20window%20pane%20at%20dusk%2C%20amber%20light%2C%20editorial%20abstract%20photography%2C%20soft%20bokeh%2C%20minimal%20tone&width=1000&height=700&seq=spcg-reflect-win&orientation=landscape&nocache=true',
  },
  {
    id: 'r2',
    tag: '镜面',
    title: '走廊尽头的方形光',
    desc: '镜面反光呈方形，和室内唯一一盏方灯对得上，可作为场景补充。',
    image:
      'https://readdy.ai/api/search-image?query=Square%20light%20reflection%20on%20a%20corridor%20mirror%2C%20warm%20amber%20glow%2C%20editorial%20minimal%20photography%2C%20muted%20neutral%20palette&width=1000&height=700&seq=spcg-reflect-mirror&orientation=landscape&nocache=true',
  },
  {
    id: 'r3',
    tag: '车漆',
    title: '车门上的一条水平线',
    desc: '水平亮线疑似对面建筑屋檐，宽度和角度都能和街景那条线对应。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20horizontal%20light%20reflection%20on%20a%20car%20door%20surface%2C%20amber%20tones%2C%20editorial%20automotive%20detail%20photography%2C%20minimal%20abstract&width=1000&height=700&seq=spcg-reflect-car&orientation=landscape&nocache=true',
  },
];

export const faqs = [
  {
    q: '「私拍吃瓜放大」到底放大的是什么？',
    a: '放大的是一帧画面里可被反复核对的部分：纹理、边缘、噪点、光斑和倒影。我们只做视觉层面的放大与标注，结论留给每一位看图的人。',
  },
  {
    q: '截图和对应片段为什么放在一起？',
    a: '静态截图方便长时间比对，动态片段能看出变化过程。两者并排，反光位移、同款细节这类线索更容易被发现。',
  },
  {
    q: '同款对照的可信度怎么保证？',
    a: '每条对照都标明来源、时间和比对基准，并列出不吻合的地方。我们只给相似度参考，不给购买建议，也不会替你做判断。',
  },
  {
    q: '背景和反光信息会更新吗？',
    a: '会。背景与反光属于会随新素材不断补充的板块，更新后会在页面顶部的更新条里出现，按时间排序，旧内容会保留档位。',
  },
  {
    q: '内容涉及他人隐私吗？',
    a: '本站只整理已公开流传素材的视觉细节，不提供原始文件下载，也不鼓励任何形式的追踪或骚扰行为。如你认为内容不妥，可随时联系我们处理。',
  },
];

export const navLinks = [
  { label: '放大', href: '#entry' },
  { label: '细节', href: '#grid' },
  { label: '同款', href: '#match' },
  { label: '背景', href: '#grid' },
  { label: '反光', href: '#reflection' },
  { label: '常见问题', href: '#faq' },
];